// Static clinic data — matches backend `/api/clinic-info` for offline resilience.
export const CLINIC = {
  name: "City Smiles Dental Clinic",
  tagline: "Your Best Smile Awaits in Ratia",
  short: "Modern, painless, and compassionate dental care for you and your family.",
  address: "Tohana Rd, opp. Sethi Sweet, Shakti Nagar, Baslan Mohalla, Ratia, Haryana 125051",
  phoneDisplay: "099969 27080",
  phoneDial: "+919996927080",
  hoursLine: "Mon – Sat · 9:00 AM – 7:00 PM  |  Sun · 10:00 AM – 2:00 PM",
  rating: 4.4,
  reviewCount: 413,
  yearsOfCare: "11+",
  establishedYear: 2014,
  instagram: "https://www.instagram.com/citysmiles2014",
  instagramHandle: "@citysmiles2014",
  facebook: "https://www.facebook.com/share/1CDcRFfA16/",
  facebookHandle: "@citysmilesratia",
  googleMapsEmbed:
    "https://www.google.com/maps?q=City+Smiles+Dental+Clinic+Ratia+Haryana&output=embed",
  googleMapsLink:
    "https://www.google.com/maps/search/?api=1&query=City+Smiles+Dental+Clinic+Ratia+Haryana",
};

export const SERVICES = [
  {
    key: "general",
    name: "General Dentistry",
    icon: "Stethoscope",
    desc: "Cleanings, fillings, and check-ups to keep your smile healthy year-round.",
  },
  {
    key: "root-canal",
    name: "Root Canal",
    icon: "Activity",
    desc: "Painless, single-sitting root canal treatments with modern rotary endodontics.",
  },
  {
    key: "whitening",
    name: "Teeth Whitening",
    icon: "Sparkles",
    desc: "Professional in-clinic whitening for a brighter, camera-ready smile.",
  },
  {
    key: "braces",
    name: "Braces / Orthodontics",
    icon: "Move",
    desc: "Metal, ceramic, and clear aligners to gently straighten your teeth.",
  },
  {
    key: "implants",
    name: "Dental Implants",
    icon: "Anchor",
    desc: "Replace missing teeth with natural-looking, long-lasting titanium implants.",
  },
  {
    key: "kids",
    name: "Kids Dentistry",
    icon: "Baby",
    desc: "Gentle, playful, fear-free dental care for our smallest patients.",
  },
  {
    key: "cosmetic",
    name: "Cosmetic Dentistry",
    icon: "Smile",
    desc: "Veneers, smile design, and reshaping — crafted for you.",
  },
];

// Two-dentist team — actual clinic team from user-provided bios
export const TEAM = [
  {
    key: "malika",
    name: "Dr. Malika",
    designation: "BDS · Co-Founder & Dental Surgeon",
    photo: "/clinic/dr-malika.jpg",
    experience: "12+ years",
    completedYear: 2011,
    bio: "Dr. Malika completed her Bachelor of Dental Surgery (BDS) in 2011 and began her career at Fortis La Femme Hospital, Greater Kailash-II, New Delhi, gaining three years of valuable clinical experience — including charitable work for underserved communities. On 24th May 2014, she co-founded City Smiles Dental Clinic in Ratia with a vision of ethical, advanced, patient-centered dental care.",
    training: "Advanced training in Dental Implants, Endodontics, Prosthetic Rehabilitation, Full-Mouth Rehab, Surgical Extractions, Aesthetic & Cosmetic Dentistry and Smile Makeovers.",
    focus: [
      "Dental Implants",
      "Root Canal Treatment",
      "Dentures & Prosthetics",
      "Full-Mouth Rehab",
      "Surgical Extractions",
      "Cosmetic Dentistry",
      "Smile Makeovers",
    ],
  },
  {
    key: "ravi",
    name: "Dr. Ravi Kant",
    designation: "BDS · Co-Founder & Dental Surgeon",
    photo: "/clinic/dr-ravi-kant.jpg",
    experience: "12+ years",
    completedYear: 2011,
    bio: "Dr. Ravi Kant completed his BDS in 2011 and started his professional career at Fortis La Femme Hospital, Greater Kailash-II, New Delhi. Alongside his hospital experience, he actively participated in charitable dental services. As co-founder of City Smiles Dental Clinic, he has been instrumental in the clinic's growth and its reputation for ethical, high-quality dental care.",
    training: "Ongoing advanced education in modern dentistry — implantology, endodontics, orthodontics, and aesthetic smile design.",
    focus: [
      "Dental Implants",
      "Root Canal Treatment",
      "Orthodontics (Braces & Aligners)",
      "Cosmetic Dentistry",
      "Composite Veneers",
      "Teeth Whitening",
      "Smile Design",
      "Restorative Dentistry",
    ],
  },
];

export const TESTIMONIALS = [
  {
    name: "Priya S.",
    location: "Ratia",
    rating: 5,
    quote:
      "The staff is incredibly kind and the clinic is spotless. My root canal was completely painless — I'll never go anywhere else.",
  },
  {
    name: "Rakesh K.",
    location: "Tohana",
    rating: 5,
    quote:
      "Dr. explained every step clearly. Got my braces here and the results are amazing. Very reasonable pricing too.",
  },
  {
    name: "Anita D.",
    location: "Fatehabad",
    rating: 5,
    quote:
      "Best dentist in the area, hands down. Took my 6-year-old for her first check-up — she actually enjoyed the visit!",
  },
  {
    name: "Manoj V.",
    location: "Ratia",
    rating: 4,
    quote:
      "Got my teeth whitened before my wedding. Fantastic results and great follow-up care.",
  },
  {
    name: "Shashi K.",
    location: "Ratia",
    rating: 5,
    quote:
      "Trusted this clinic for our whole family for years. Dr. Malika and Dr. Ravi Kant are the best team in the region.",
  },
];

// Real clinic before/after work — from clinic archive
export const RESULTS = [
  {
    key: "implants",
    label: "Dental Implants",
    image: "/clinic/implants-before-after.jpg",
    caption: "Full-mouth rehabilitation with implant-supported prosthesis.",
  },
  {
    key: "braces",
    label: "Braces / Orthodontics",
    image: "/clinic/colorful-braces.jpg",
    caption: "Colourful ceramic braces — a favourite with teens.",
  },
  {
    key: "aligners",
    label: "Clear Aligners",
    image: "/clinic/clear-aligners.jpg",
    caption: "Invisible aligner therapy for a discreet smile transformation.",
  },
  {
    key: "fillings",
    label: "Tooth-Coloured Fillings",
    image: "/clinic/filling-before-after.jpg",
    caption: "Old metal fillings replaced with natural-looking composite.",
  },
  {
    key: "whitening",
    label: "Teeth Whitening",
    image: "/clinic/whitening-result.jpg",
    caption: "Professional in-clinic whitening — visible in a single visit.",
  },
  {
    key: "kids",
    label: "Kids Dentistry",
    image: "/clinic/kids-dentistry.jpg",
    caption: "Gentle, fear-free care for our smallest patients.",
  },
];

export const TRUST_STATS = [
  { label: "Years of Care", value: "11+" },
  { label: "Happy Patients", value: "50,000+" },
  { label: "Google Rating", value: "4.4★" },
  { label: "Painless Tech", value: "100%" },
];

export const COMMITMENT = {
  quote: "Creating Healthy Smiles with Precision, Compassion & Excellence.",
  body:
    "Established on 24th May 2014, City Smiles Dental Clinic has been dedicated to providing comprehensive, ethical, and advanced dental care to patients of all ages. Combining years of clinical experience, continuous professional training, and modern technology, Dr. Malika and Dr. Ravi Kant strive to deliver comfortable, personalised, and high-quality treatment in a warm and welcoming environment.",
  short:
    "One of the trusted dental care centres in Ratia and the surrounding region — with over 50,000 happy patients and counting.",
};
